import apiClient from './client'

// ---------------------------------------------------------------------------
// Response types — mirrors backend BattingStatsRow / PitchingStatsRow
// ---------------------------------------------------------------------------

export interface BattingStatsRow {
  player_id: number | null
  player_name: string | null
  team_id: number | null
  team_abbreviation: string | null
  season_year: number | null
  aggregation_period: string
  split_type: string
  split_value: string
  games: number | null
  plate_appearances: number | null
  at_bats: number | null
  runs: number | null
  hits: number | null
  doubles: number | null
  triples: number | null
  home_runs: number | null
  rbi: number | null
  walks: number | null
  strikeouts: number | null
  stolen_bases: number | null
  caught_stealing: number | null
  hit_by_pitch: number | null
  sacrifice_flies: number | null
  sacrifice_hits: number | null
  grounded_into_dp: number | null
  intentional_walks: number | null
  reached_on_error: number | null
  ground_balls: number | null
  fly_balls: number | null
  line_drives: number | null
  popups: number | null
  batting_avg: number | null
  on_base_pct: number | null
  slugging_pct: number | null
  ops: number | null
  isolated_power: number | null
  babip: number | null
  woba: number | null
  wrc_plus: number | null
  bippi: number | null
  groundball_rate: number | null
  pull_pct: number | null
  infield_hit_rate: number | null
  tobp: number | null
  tslg: number | null
  tops: number | null
}

export interface PitchingStatsRow {
  player_id: number | null
  player_name: string | null
  team_id: number | null
  team_abbreviation: string | null
  season_year: number | null
  aggregation_period: string
  split_type: string
  split_value: string
  games: number | null
  games_started: number | null
  wins: number | null
  losses: number | null
  saves: number | null
  holds: number | null
  innings_pitched: number | null
  hits: number | null
  runs: number | null
  earned_runs: number | null
  home_runs: number | null
  walks: number | null
  strikeouts: number | null
  hit_batters: number | null
  wild_pitches: number | null
  balks: number | null
  intentional_walks: number | null
  ground_balls: number | null
  fly_balls: number | null
  line_drives: number | null
  popups: number | null
  plate_appearances_faced: number | null
  era: number | null
  whip: number | null
  twhip: number | null
  tera: number | null
  siera_plus: number | null
  k_per_9: number | null
  bb_per_9: number | null
  k_per_bb: number | null
  fip: number | null
  xfip: number | null
  hr_per_9: number | null
  groundball_pct: number | null
  flyball_pct: number | null
  pfi: number | null
}

export interface StatsPage<T> {
  data: T[]
  total: number
  limit: number
  offset: number
}

// ---------------------------------------------------------------------------
// Query params
// ---------------------------------------------------------------------------

export interface BattingLeaderboardParams {
  year?: string
  split?: string
  sort_by?: string
  sort_dir?: string
  min_pa?: number
  aggregation_period?: string
  player_id?: number
  team_id?: number
  limit?: number
  offset?: number
}

export interface PitchingLeaderboardParams {
  year?: string
  split?: string
  sort_by?: string
  sort_dir?: string
  min_ip?: number
  aggregation_period?: string
  player_id?: number
  team_id?: number
  limit?: number
  offset?: number
}

// ---------------------------------------------------------------------------
// API client
// ---------------------------------------------------------------------------

export const statsApi = {
  async getBatting(params: BattingLeaderboardParams): Promise<StatsPage<BattingStatsRow>> {
    const response = await apiClient.get<StatsPage<BattingStatsRow>>('/stats/batting', { params })
    return response.data
  },

  async getPitching(params: PitchingLeaderboardParams): Promise<StatsPage<PitchingStatsRow>> {
    const response = await apiClient.get<StatsPage<PitchingStatsRow>>('/stats/pitching', { params })
    return response.data
  }
}

export default statsApi
